module.exports = __webpack_public_path__ + "img/yanaraaedo.e905b894.jpg";